module.exports = __webpack_public_path__ + "static/media/rotary_international_1.40c9f416.jpg";